import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SalesProtected = (props) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate("/loginsaleshead");
    }
  }, [token]);

  let Cmp = props.Cmp;
  return (
    <div>
      <Cmp />
    </div>
  );
};

export default SalesProtected;
